// extracted by mini-css-extract-plugin
module.exports = {"figure":"image-asset-module--figure--26yzK","imageContainer":"image-asset-module--imageContainer--1cdFi","figcaption":"image-asset-module--figcaption--7Xcev"};